export default __webpack_public_path__ + "static/media/to-do.3deb9f98.svg";